import { FormFieldMappingType, FormFieldEnum } from 'types/FormFieldMappingType'

type DefaultMapping = {
  rawKey: string
  formField: FormFieldEnum
  valueMap?: Record<string, unknown>
}

const defaultMappings: DefaultMapping[] = [
  { rawKey: `First Name`, formField: `patientNameFirst` },
  { rawKey: `Last Name`, formField: `patientNameLast` },
  { rawKey: `Name`, formField: `patientName` },
  { rawKey: `Email`, formField: `email` },
  { rawKey: `Email Address`, formField: `email` },
  { rawKey: `Phone`, formField: `phone` },
  { rawKey: `Phone Number`, formField: `phone` },
  { rawKey: `Are you a new patient?`, formField: `newPatient`, valueMap: { Yes: true, No: false } },
  {
    rawKey: `Are You a New or Existing Patient?`,
    formField: `newPatient`,
    valueMap: { 'New Patient': true, 'Existing Patient': false },
  },
  { rawKey: `How Did You Find Us?`, formField: `source` },
  { rawKey: `Date`, formField: `requestedAppointmentDateDate` },
  { rawKey: `Time`, formField: `requestedAppointmentDateTime` },
  { rawKey: `typeA`, formField: `referralURL` },
  { rawKey: `firstName`, formField: `patientNameFirst` },
  { rawKey: `lastName`, formField: `patientNameLast` },
  { rawKey: `first_name`, formField: `patientNameFirst` },
  { rawKey: `first name`, formField: `patientNameFirst` },
  { rawKey: `firstname`, formField: `patientNameFirst` },
  { rawKey: `last_name`, formField: `patientNameLast` },
  { rawKey: `last name`, formField: `patientNameLast` },
  { rawKey: `lastname`, formField: `patientNameLast` },
  { rawKey: `full_name`, formField: `patientName` },
  { rawKey: `treatment`, formField: `treatment` },
  { rawKey: `service`, formField: `treatment` },
  { rawKey: `source`, formField: `source` },
  { rawKey: `referral`, formField: `source` },
  { rawKey: `howDid`, formField: `source` },
  { rawKey: `areYou`, formField: `newPatient`, valueMap: { Yes: true, No: false } },
  { rawKey: `newPatient`, formField: `newPatient`, valueMap: { Yes: true, No: false } },
  { rawKey: `reasonFor`, formField: `treatment` },
  { rawKey: `patientName`, formField: `patientName` },
  { rawKey: `email`, formField: `email` },
  { rawKey: `phone`, formField: `phone` },
  { rawKey: `phone_number`, formField: `phone` },
  { rawKey: `treatment_interest`, formField: `treatment` },
  { rawKey: `appointmentDate`, formField: `requestedAppointmentDate` },
  { rawKey: `appointmentRequest`, formField: `requestedAppointmentDate` },
  { rawKey: `full name`, formField: `patientName` },
]

// Original non-exact mappings (removed — users should create custom mappings via UI if needed):
// Contains-all:
//   { rawKey: `new|patient`, matchType: `contains-all`, formField: `newPatient`, valueMap: { yes: true, Yes: true, new: true, New: true } }
//   { rawKey: `appointment|date`, matchType: `contains-all`, formField: `requestedAppointmentDate` }
// Contains (duplicates of exact mappings above):
//   { rawKey: `phone`, matchType: `contains`, formField: `phone` } — duplicate of Phone
//   { rawKey: `email`, matchType: `contains`, formField: `email` } — duplicate of Email
// Regex:
//   { rawKey: `^(name|patientName)$`, matchType: `regex`, formField: `patientName` }
//   { rawKey: `appointment|request`, matchType: `regex`, formField: `requestedAppointmentDate` }

function deduplicateMappings(mappings: DefaultMapping[]): FormFieldMappingType[] {
  const seen = new Set<string>()
  return mappings.filter((m) => {
    const key = `${m.rawKey.toLowerCase()}|${m.formField}`
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}

export const defaultFormFieldMappings: FormFieldMappingType[] = deduplicateMappings(defaultMappings)

export function getDefaultMappings(): FormFieldMappingType[] {
  return defaultFormFieldMappings
}

export const formFieldOptions: { value: string; label: string }[] = [
  { value: `formTitle`, label: `Form Title` },
  { value: `patientName`, label: `Patient Name` },
  { value: `patientNameFirst`, label: `Patient First Name` },
  { value: `patientNameLast`, label: `Patient Last Name` },
  { value: `email`, label: `Email` },
  { value: `phone`, label: `Phone` },
  { value: `newPatient`, label: `New Patient` },
  { value: `source`, label: `Source` },
  { value: `treatment`, label: `Treatment` },
  { value: `requestedAppointmentDate`, label: `Requested Appointment Date` },
  { value: `referralURL`, label: `Referral URL` },
  { value: `channel`, label: `Channel` },
  { value: `utmSource`, label: `UTM Source` },
  { value: `utmMedium`, label: `UTM Medium` },
  { value: `utmCampaign`, label: `UTM Campaign` },
  { value: `utmContent`, label: `UTM Content` },
  { value: `utmKeywords`, label: `UTM Keywords` },
]
